import {
  HOME_REGIONS,
  HOME_REGIONS_ALIAS,
  HOME_REGIONS_ALIAS_IDS,
  HOME_REGIONS_ALIAS_REGION_NAMES,
} from '~/shared/constants'

export const checkLandingRegion = (region = ''): boolean => {
  return Object.keys(HOME_REGIONS).includes(
    region.toLowerCase() as keyof typeof HOME_REGIONS
  )
}

export const checkLandingAlias = (alias = ''): boolean => {
  return Object.keys(HOME_REGIONS_ALIAS).includes(
    alias.toLowerCase() as keyof typeof HOME_REGIONS_ALIAS
  )
}

export const getLandingRegionUrlFromAlias = (alias = ''): string => {
  return (
    HOME_REGIONS_ALIAS[
      alias.toLowerCase() as keyof typeof HOME_REGIONS_ALIAS
    ] || ''
  )
}

/** Live TV region behind a landing page, to link from its content to the Live TV module */
export const getLandingRegionFromAlias = (
  alias = ''
): { id: number; name: string } | null => {
  const key = alias.toLowerCase() as keyof typeof HOME_REGIONS_ALIAS_IDS
  const id = HOME_REGIONS_ALIAS_IDS[key]

  return id ? { id, name: HOME_REGIONS_ALIAS_REGION_NAMES[key] ?? '' } : null
}
